module.exports = __webpack_public_path__ + "static/media/haben_girma.f3b1bbd2.jpg";